// import React, { useEffect, useState } from "react";

// const ExportReportsBHM = ({
//     accounts,
//     selectedAccount: selectedAccountProp,
//     onClose,
//     onExport,
//     reportType,
//     t,
//     i18n,
// }) => {
//     const [selectedClientId, setSelectedClientId] = useState(
//         selectedAccountProp?.ClientID ||
//         (accounts && accounts.length > 0 ? accounts[0].ClientID : "")
//     );




//     const [period, setPeriod] = useState(""); 
//     const [periodOptions, setPeriodOptions] = useState([]);

//     useEffect(() => {
//         if (selectedAccountProp && selectedAccountProp.ClientID) {
//             setSelectedClientId(selectedAccountProp.ClientID);
//         }
//     }, [selectedAccountProp]);

//     useEffect(() => {
//         const arr = [];
//         const now = new Date();

//         for (let i = 0; i < 6; i++) {
//             const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
//             const year = d.getFullYear();
//             const monthNumber = d.getMonth() + 1; // 1..12
//             const monthShort = d.toLocaleString("en-US", { month: "short" }); // Jan, Feb, ...

//             arr.push({
//                 value: `${year}-${monthNumber.toString().padStart(2, "0")}`, // 2025-11
//                 label: `${year}-${monthShort}`, // 2025-Nov
//             });
//         }

//         setPeriodOptions(arr);
//         if (arr.length > 0) {
//             setPeriod(arr[0].value);
//         }
//     }, []);

//     const handleExportClick = () => {
//         if (!selectedClientId || !period) return;

//         const account = accounts.find((a) => a.ClientID === selectedClientId);
//         if (!account) return;

//         onExport &&
//             onExport({
//                 account,
//                 reportType,
//                 period,
//                 onClose,
//             });
//     };

    

//     const isArabic = i18n.language === "ar";

//     return (
//         <div
//             className="export-reports-container"
//             style={{  paddingBlock: "8px" , textAlign:"start" }}
//         >
//             {/* Account */}
//             <div className="mb-3">
//                 <label className="lableCustomized" style={{ display: "block" }}>
//                     {t("account")}
//                 </label>
//                 <select
//                     className="form-control"
//                     value={selectedClientId}
//                     disabled
//                 >
//                     {accounts &&
//                         accounts.map((acc) => (
//                             <option key={acc.ClientID} value={acc.ClientID}>
//                                 {i18n.language === "ar"
//                                     ? acc.ClientNameA || ""
//                                     : acc.ClientNameE || ""}
//                             </option>
//                         ))}
//                 </select>
//             </div>


//             {/* Report Type */}
//             <div className="mb-3">
//                 <label className="lableCustomized" style={{ display: "block" }}>
//                     {t("ReportType")}
//                 </label>
//                 <select
//                     className="form-control"
//                     value={reportType}
//                     disabled
//                 >
//                     <option value="HOLDING_STATEMENT">
//                         {t("Holding Statement") || "Holding Statement"}
//                     </option> 
//                     <option value="Cash_STATEMENT">
//                         {t("Cash Statement") || "Cash Statement"}
//                     </option>
//                 </select>
//             </div>

//             {/* Period */}
//             <div className="mb-4">
//                 <label className="lableCustomized" style={{ display: "block" }}>
//                     {t("Period")}
//                 </label>
//                 <select
//                     className="form-control"
//                     value={period}
//                     onChange={(e) => setPeriod(e.target.value)}
//                 >
//                     {periodOptions.map((p) => (
//                         <option key={p.value} value={p.value}>
//                             {p.label}
//                         </option>
//                     ))}
//                 </select>
//             </div>

//             {/* Export button */}
//             <div style={{ textAlign: "center" }}>
//                 <button
//                     type="button"
//                     className="btn btn-primary"
//                     onClick={handleExportClick}
//                 >
//                     {t("Export") || "Export"}
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default ExportReportsBHM;



import React, { useEffect, useRef, useState } from "react";

const ExportReportsBHM = ({
  accounts,
  selectedAccount: selectedAccountProp,
  onClose,
  onExport,
  reportType,
  t,
  i18n,
}) => {
  const [selectedClientId, setSelectedClientId] = useState(
    selectedAccountProp?.ClientID ||
      (accounts && accounts.length > 0 ? accounts[0].ClientID : "")
  );

  const [period, setPeriod] = useState("");
  const [periodOptions, setPeriodOptions] = useState([]);

  // ✅ NEW: lock to prevent double click
  const exportLockRef = useRef(false);
  const [disableExportBtn, setDisableExportBtn] = useState(false);

  useEffect(() => {
    if (selectedAccountProp && selectedAccountProp.ClientID) {
      setSelectedClientId(selectedAccountProp.ClientID);
    }
  }, [selectedAccountProp]);

  useEffect(() => {
    const arr = [];
    const now = new Date();

    for (let i = 0; i < 6; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const year = d.getFullYear();
      const monthNumber = d.getMonth() + 1;
      const monthShort = d.toLocaleString("en-US", { month: "short" });

      arr.push({
        value: `${year}-${monthNumber.toString().padStart(2, "0")}`,
        label: `${year}-${monthShort}`,
      });
    }

    setPeriodOptions(arr);
    if (arr.length > 0) setPeriod(arr[0].value);
  }, []);

  const handleExportClick = () => {
    if (!selectedClientId || !period) return;

    // ✅ prevent double click
    if (exportLockRef.current) return;
    exportLockRef.current = true;
    setDisableExportBtn(true);

    const account = accounts.find((a) => a.ClientID === selectedClientId);
    if (!account) {
      exportLockRef.current = false;
      setDisableExportBtn(false);
      return;
    }

    onExport &&
      onExport({
        account,
        reportType,
        period,
        onClose,
      });

    setTimeout(() => {
      exportLockRef.current = false;
      setDisableExportBtn(false);
    }, 1500);
  };

  const isArabic = i18n.language === "ar";

  return (
    <div
      className="export-reports-container"
      style={{ paddingBlock: "8px", textAlign: "start" }}
    >
      {/* Account */}
      <div className="mb-3">
        <label className="lableCustomized" style={{ display: "block" }}>
          {t("account")}
        </label>
        <select className="form-control" value={selectedClientId} disabled>
          {accounts &&
            accounts.map((acc) => (
              <option key={acc.ClientID} value={acc.ClientID}>
                {i18n.language === "ar"
                  ? acc.ClientNameA || ""
                  : acc.ClientNameE || ""}
              </option>
            ))}
        </select>
      </div>

      {/* Report Type */}
      <div className="mb-3">
        <label className="lableCustomized" style={{ display: "block" }}>
          {t("ReportType")}
        </label>
        <select className="form-control" value={reportType} disabled>
          <option value="HOLDING_STATEMENT">
            {t("Holding Statement") || "Holding Statement"}
          </option>
          <option value="Cash_STATEMENT">
            {t("Cash Statement") || "Cash Statement"}
          </option>
        </select>
      </div>

      {/* Period */}
      <div className="mb-4">
        <label className="lableCustomized" style={{ display: "block" }}>
          {t("Period")}
        </label>
        <select
          className="form-control"
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          disabled={disableExportBtn}
        >
          {periodOptions.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
      </div>

      {/* Export button */}
      <div style={{ textAlign: "center" }}>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleExportClick}
          disabled={disableExportBtn}
        >
          {t("Export") || "Export"}
        </button>
      </div>
    </div>
  );
};

export default ExportReportsBHM;
